import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/404";
import Appstore from "./pages/appstore";
import CmsPage from "./pages/cms/CmsPage";
import Refund from "./pages/helpers/redund";
import InviteAccept from "./pages/invite";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Settings from "./pages/settings";
import Updraft from "./pages/updraft";
import GlobalActivity from "./pages/cms/components/GlobalActivity";

const App = () => {
  return (
    <Layout>
      <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar closeButton={false} theme="light" newestOnTop />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/invite/:token" element={<InviteAccept />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Appstore />
            </ProtectedRoute>
          }
        />
        <Route
          path="/updraft"
          element={
            <ProtectedRoute>
              <Updraft />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activity"
          element={
            <ProtectedRoute requiredRole="admin">
              <GlobalActivity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/helpers/refund"
          element={
            <ProtectedRoute>
              <Refund />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cms/*"
          element={
            <ProtectedRoute requiredRole="editor">
              <CmsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute requiredRole="admin">
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

export default App;
